// extracted by mini-css-extract-plugin
export default {"Box":"InfobarPopover-module__Box--TeHD6","CircleOcticon":"InfobarPopover-module__CircleOcticon--LHncx"};